import React, { useEffect, useState, useRef } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import "../Scss/Layout/_dashboard.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { logOut } from "../store/actions/CommonAction";
import { ToastContainer, toast } from 'react-toastify';
// import { Pie } from 'react-chartjs-2';

import CanvasJSReact from '@canvasjs/react-charts';
import {
  getVerfiybyConsentId,
  clearSession,
  getGroupNames,
} from "../store/actions/CommonAction";
import {
  getDashboard,
  getConsentdetailsByTemplateId,
  getEntityList,
  getPurpose,
  getDatatype,
  getConsentDataFromJsonList,
  getmanageDSR,
  getProfileData,
  transferObjectFromDashboard
} from "../store/actions/CommonAction";
import { exportToExcel } from "../utils/ExportToExcel";
import { Link } from "@mui/material";

const Dashboard = () => {

  const [values, setValues] = useState({
    select1: "",
    select2: "",
    select3: "",
    select4: "",
  });


  //pagination

  


  var graphDataInit = [];

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const exportRef = useRef(null);
  const history = useHistory();
  const sessionId = useSelector((state) => state.common.sessionId);
  const clientId = useSelector((state) => state.common.clientId);
  const [shouldRenderGrid, setShouldRenderGrid] = useState(false);
  const clientIdForDashboard = useSelector(
    (state) => state.common.clientIdForDashboard
  );
  const dashboarddata = useSelector((state) => state.common.dashboarddata);
  console.log("dashboarddata: "+JSON.stringify(dashboarddata));
  const [gridData, setGridData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const [itemVal, setItem] = useState();
  const consentDetailList = useSelector(
    (state) => state.common.getConsentDetail
  );
  const consentDataArrayValue = useSelector(
    (state) => state.common.consentDataArrayValue
  );
  const [isLoadingMain, setIsLoadingMain] = useState(true);
  const accountId = useSelector((state) => state.common.accountIdUAM);
  //alert("accountIdUAM"+ JSON.stringify(accountId))
  const groupId = useSelector((state) => state.common.groupIdUAM);
  //alert("groupIdUAM"+ JSON.stringify(groupId))
  const userId = useSelector((state) => state.common.userIdUAM);
  const [groupNames, setGroupNames] = useState([]);
  const clientIdUam = useSelector((state) => state.common.clientIdUam);
  const clientSecretUam = useSelector((state) => state.common.clientSecretUam);
  const groupIdUam = useSelector((state) => state.common.groupIdUam);
  const profileData = useSelector(state => state.common.profileData)

  const handleClose = async () => {
    setIsLoading(true);
    setGridData("");
    setShow(!show);
    // callAPI()
    await dispatch(getDashboard());
    await dispatch(getEntityList());
    // await dispatch(getPurpose())
    // await dispatch(getDatatype())
  };

  const handleExportClick = () => {
    exportToExcel(dashboarddata, "dashboard.xlsx");
  };

  const viewDetail = async (item) => {
    setItem(item);
    console.log(itemVal);
    await dispatch(getConsentdetailsByTemplateId(item));
    await dispatch(getConsentDataFromJsonList(consentDetailList));
    // alert("dataTableValue : "+JSON.stringify(dataTableValue));
    setShow(!show);
    setTimeout(function () {
      setGridData(consentDataArrayValue);
      setIsLoading(false);
    }, 1000);
  };

  const callAPI = async () => {
    setIsLoadingMain(true);
    try {
      await dispatch(getDashboard());
      await dispatch(getEntityList());
      await dispatch(getPurpose());
      await dispatch(getDatatype());
      await dispatch(getProfileData(clientId))
    } catch (error) {
      console.error(error);
    }
    setIsLoadingMain(false);
  };

  const signOut = async () => {
    await dispatch(logOut());
    // await dispatch(hideNavbar(false))
    //localStorage.clear();
    history.push("/");
    window.location.reload();
  };

  const formatDate = (isoDateString) => {
    // Create a Date object from the ISO string
    const date = new Date(isoDateString);
  
    // Extract day, month, and year
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getUTCFullYear();
  
    // Format the date as dd/mm/yyyy
    return `${day}/${month}/${year}`;
  };

  // const isoDateString = '2024-08-05T12:10:52.406Z';
  // const formattedDate = formatDate(isoDateString);

  const currentYear = new Date().getFullYear();

  let dataPoints = [];
  
  // If dashboarddata and graphData exist
  if (dashboarddata && dashboarddata.graphData) {
      // Iterate over all 12 months (0 for January, 11 for December)
      for (let month = 0; month < 12; month++) {
          const monthString = (month + 1).toString().padStart(2, '0'); // Convert month to 2-digit string
          dataPoints.push({
              x: new Date(currentYear, month), // Create a Date object for the current month
              y: dashboarddata.graphData[monthString] || 0 // Use the value from graphData or default to 0
          });
      }
  }
  
  console.log(JSON.stringify(dataPoints));
  
//alert("dataPoints : "+dataPoints.length);
  // useEffect(() => {
  //     getGroupNames(groupId,accountId).then(groups => setGroupNames(groups));
  //     console.log("+" +getGroupNames)
  // }, [groupId]);

  // useEffect(() => {
  //     //getGroupNames (groupId,accountId);
  //     fetchGroupData(groupId, accountId);
  // }, []);

  // async function fetchGroupData(groupId, accountId) {
  //     const url = `http://10.162.6.84:10017/uam/v1.0/getGroups?groupId=${groupId}&accountId=${accountId}`;

  //     try {
  //       const response = await fetch(url);

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }

  //       const data = await response.json();
  //       // Handle the response data here
  //       // For example: alert(`accountHierarichyData-->${JSON.stringify(data)}`)
  //       return data; // Return data to be used by the caller of this function

  //     } catch (error) {
  //       // Handle errors during the fetch
  //       console.error("Fetch error:", error);
  //       throw error; // Rethrow the error to be handled by the caller if necessary
  //     }
  //   }


  var CanvasJS = CanvasJSReact.CanvasJS;
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;

  const optionsGraph = {
    animationEnabled: true,
    height: 270,
    width: 1050,
    title: {
      // text: "Monthly Sales - 2017"
    },
    axisX: {
      valueFormatString: "MMM",
      gridColor: "lightgrey",  
      tickColor: "lightgrey",  
      lineThickness: 0,        
      labelFontWeight: "bold"  
    },
    axisY: {
      includeZero: true,
      gridColor: "lightgrey",  
      tickColor: "lightgrey",  
      lineThickness: 0,        
      labelFontWeight: "bold"  
    },
    data: [{
      yValueFormatString: "#,###", // Format large numbers with commas
      xValueFormatString: "MMMM",
      type: "spline",
      markerSize: 10,
      dataPoints: dataPoints
    }]
  }


  const handleObjectTransfer = (consentGroupElement) => {
    try {
      console.log("consentGroupElement : "+JSON.stringify(consentGroupElement));
      const targetUrl = `/templatelist/${encodeURIComponent('fromDashboard')}`;
      dispatch(transferObjectFromDashboard(consentGroupElement));
      history.push(targetUrl);
    } catch (error) {
      console.error('An error occurred during object transfer:', error);
    }
  };




  useEffect(() => {

    if(!sessionStorage.getItem('sessionId')){
      toast.error(`Your Session has Expired: Please login again`);
        window.location.href = '/login';
    }

    //console.log("Inside if only, Not in else Part" + " " +sessionId )
    if (!sessionId) {
      console.log("Inside if only not in else" + " " + sessionId);
      signOut();
    } else {
      console.log("Sucess..............." + " " + sessionId);
    //   alert("fghjklkjshshsjjsvbsnjkjhgfg scghuiuytfdfghjs");
      callAPI();
      // alert("getProductTheme.theme : "+getProductTheme.theme);
      // applyTheme();

      if (show) {
        const timer = setTimeout(() => {
          setShouldRenderGrid(true);
        }, 100); // Adjust the delay value as needed
        // Clear the timer on unmount / effect re-run
        return () => clearTimeout(timer);
      } else {
        setShouldRenderGrid(false);
      }
    }
  }, [show, sessionId, clientIdUam]);

  useEffect(() => {
    const handleUnload = () => {
      // Perform actions before the component unloads
      dispatch(clearSession());
    };
    window.addEventListener("unload", handleUnload);
    return () => {
      window.removeEventListener("unload", handleUnload);
    };


    


  }, [dispatch]);

  const callRefresh = async () => {
    await window.location.reload();
  };

  const openPopOver = (id, value) => {
    if (document.getElementById(id + value).style.display == "block") {
      document.getElementById(id + value).style.display = "none";
    } else {
      document.getElementById(id + value).style.display = "block";
    }
  };

  // const totalActiveConsent =
  // clientId === clientIdForDashboard && dashboarddata.meta.totalActiveConsent !== undefined
  //     ? dashboarddata.meta.totalActiveConsent
  //     : 0;
   
  // const totalRevokedConsent=
  // clientId === clientIdForDashboard &&
  //     dashboarddata.meta.totalRevokedConsent !== undefined
  //       ? dashboarddata.meta.totalRevokedConsent
  //       : 0;
   
  // const totalExpiredConsent=
  // clientId === clientIdForDashboard &&
  //     dashboarddata.meta.totalExpiredConsent !== undefined
  //       ? dashboarddata.meta.totalExpiredConsent
  //       : 0;
  // const totalRejectedConsent=
  // clientId === clientIdForDashboard && dashboarddata.meta.totalRejectedConsent !== undefined
  //     ? dashboarddata.meta.totalRejectedConsent
  //   : 0;
   
   
  // const pieParams = { height: 200, margin: { right: 5 } };
  // const palette = ['green', 'blue', 'grey', 'red'];
   
  // const data = {
  //  labels: ['Active', 'Revoked', 'Expired', 'Rejected'],
  //   datasets: [
  //     {
  //     //   data: [3, 13, 15, 8],
  //       data: [totalActiveConsent, totalRevokedConsent, totalExpiredConsent, totalRejectedConsent],
  //       backgroundColor: palette,
  //     },
  //   ],
  // };
   
  // const options = {
  //     plugins: {
  //       tooltip: {
  //         callbacks: {
  //           label: function (context) {
  //             const label = context.label || '';
  //             const value = context.raw || 0;
  //             return `${label}: ${value}`;
  //             return null;
  //           },
  //         },
         
  //       },
  //     },
      // maintainAspectRatio: true,
    // };
   
    // const optionsGraph = {
    //   animationEnabled: true,
    //   height: 310,
    //   width: 683,
    //   title: {
    //     // text: "Monthly Sales - 2017"
    //   },
    //   axisX: {
    //     valueFormatString: "MMM",
    //     gridColor: "lightgrey",  
    //     tickColor: "lightgrey",  
    //     lineThickness: 0,        
    //     labelFontWeight: "bold"  
    //   },
    //   axisY: {
    //     includeZero: true,
    //     gridColor: "lightgrey",  
    //     tickColor: "lightgrey",  
    //     lineThickness: 0,        
    //     labelFontWeight: "bold"  
    //   },
    //   data: [{
    //     yValueFormatString: "#,###", // Format large numbers with commas
    //     xValueFormatString: "MMMM",
    //     type: "spline",
    //     markerSize: 10,
    //     dataPoints: [
    //         { x: new Date(2017, 0), y: 20, markerColor: "red" },
    //         { x: new Date(2017, 1), y: 150, },
    //         { x: new Date(2017, 2), y: 225, markerColor: "green" },
    //         { x: new Date(2017, 3), y: 200, markerColor: "grey" },
    //         { x: new Date(2017, 4), y: 125, markerColor: "green" },
    //         { x: new Date(2017, 5), y: 80,  },
    //         { x: new Date(2017, 6), y: 175, markerColor: "" },
    //         { x: new Date(2017, 7), y: 250, markerColor: "red" },
    //         { x: new Date(2017, 8), y: 300, markerColor: "grey" },
    //         { x: new Date(2017, 9), y: 250  },
    //         { x: new Date(2017, 10), y: 120, markerColor: "green" },
    //         { x: new Date(2017, 11), y: 80 }
    //     ]
    //   }]
    // }



  // const verifycvc = async (consentId) => {
  //   try {
  //     await dispatch(getVerfiybyConsentId(consentId))

  //     setShowCVCModal(!showCVCModal)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  return (
    <>
      <section className="content-header" style={{marginTop:'6%'}}>
        <div className="container" >
          <div className="row align-items-center">
            <div className="col-md-5">
              <h1 className="page-title">Hello, {profileData.appName} </h1>
            </div>
            <div className="col-md-7 text-end">
              
              <button
                className="btn btn-outline-primary btn-lg btn-r25 px-3"
                onClick={handleExportClick}
              >
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.02667 11.14C8.08864 11.2025 8.16238 11.2521 8.24362 11.2859C8.32486 11.3198 8.41199 11.3372 8.5 11.3372C8.58801 11.3372 8.67515 11.3198 8.75638 11.2859C8.83762 11.2521 8.91136 11.2025 8.97333 11.14L10.9733 9.14001C11.0989 9.01447 11.1694 8.84421 11.1694 8.66668C11.1694 8.48914 11.0989 8.31888 10.9733 8.19334C10.8478 8.06781 10.6775 7.99728 10.5 7.99728C10.3225 7.99728 10.1522 8.06781 10.0267 8.19334L9.16667 9.06001V2.00001C9.16667 1.8232 9.09643 1.65363 8.9714 1.52861C8.84638 1.40358 8.67681 1.33334 8.5 1.33334C8.32319 1.33334 8.15362 1.40358 8.0286 1.52861C7.90357 1.65363 7.83333 1.8232 7.83333 2.00001V9.06001L6.97333 8.19334C6.8478 8.06781 6.67753 7.99728 6.5 7.99728C6.32247 7.99728 6.1522 8.06781 6.02667 8.19334C5.90113 8.31888 5.83061 8.48914 5.83061 8.66668C5.83061 8.84421 5.90113 9.01447 6.02667 9.14001L8.02667 11.14ZM13.8333 8.00001C13.6565 8.00001 13.487 8.07025 13.3619 8.19527C13.2369 8.3203 13.1667 8.48987 13.1667 8.66668V12.6667C13.1667 12.8435 13.0964 13.0131 12.9714 13.1381C12.8464 13.2631 12.6768 13.3333 12.5 13.3333H4.5C4.32319 13.3333 4.15362 13.2631 4.0286 13.1381C3.90357 13.0131 3.83333 12.8435 3.83333 12.6667V8.66668C3.83333 8.48987 3.7631 8.3203 3.63807 8.19527C3.51305 8.07025 3.34348 8.00001 3.16667 8.00001C2.98986 8.00001 2.82029 8.07025 2.69526 8.19527C2.57024 8.3203 2.5 8.48987 2.5 8.66668V12.6667C2.5 13.1971 2.71071 13.7058 3.08579 14.0809C3.46086 14.456 3.96957 14.6667 4.5 14.6667H12.5C13.0304 14.6667 13.5391 14.456 13.9142 14.0809C14.2893 13.7058 14.5 13.1971 14.5 12.6667V8.66668C14.5 8.48987 14.4298 8.3203 14.3047 8.19527C14.1797 8.07025 14.0101 8.00001 13.8333 8.00001Z"
                    fill="#0A2885"
                  />
                </svg>
                Download Report
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="content h-100">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="consent-status">
                <h4>Consent Groups and Templates</h4>
                <div className="row">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <div className="status-box c1">
                      <label>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 12.75C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75C11.8011 3.75 11.6103 3.82902 11.4697 3.96967C11.329 4.11032 11.25 4.30109 11.25 4.5V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303C11.6103 12.671 11.8011 12.75 12 12.75ZM9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V7.5C9.75 7.30109 9.67098 7.11032 9.53033 6.96967C9.38968 6.82902 9.19891 6.75 9 6.75C8.80109 6.75 8.61032 6.82902 8.46967 6.96967C8.32902 7.11032 8.25 7.30109 8.25 7.5V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM6 12.75C6.19891 12.75 6.38968 12.671 6.53033 12.5303C6.67098 12.3897 6.75 12.1989 6.75 12V9C6.75 8.80109 6.67098 8.61032 6.53033 8.46967C6.38968 8.32902 6.19891 8.25 6 8.25C5.80109 8.25 5.61032 8.32902 5.46967 8.46967C5.32902 8.61032 5.25 8.80109 5.25 9V12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303C5.61032 12.671 5.80109 12.75 6 12.75ZM15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V12C14.25 12.1989 14.329 12.3897 14.4697 12.5303C14.6103 12.671 14.8011 12.75 15 12.75C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM15 14.25H3.75V3C3.75 2.80109 3.67098 2.61032 3.53033 2.46967C3.38968 2.32902 3.19891 2.25 3 2.25C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25Z"
                            fill="black"
                          />
                        </svg>
                        Total
                      </label>
                      <h1> {clientId === clientIdForDashboard && dashboarddata.meta.totalConsentGroups !== undefined ? dashboarddata.meta.totalConsentGroups: 0}<span>Consent Groups</span>
                      </h1>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3 mb-md-0">
                    <div className="status-box c2">
                      <label>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 12.75C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75C11.8011 3.75 11.6103 3.82902 11.4697 3.96967C11.329 4.11032 11.25 4.30109 11.25 4.5V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303C11.6103 12.671 11.8011 12.75 12 12.75ZM9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V7.5C9.75 7.30109 9.67098 7.11032 9.53033 6.96967C9.38968 6.82902 9.19891 6.75 9 6.75C8.80109 6.75 8.61032 6.82902 8.46967 6.96967C8.32902 7.11032 8.25 7.30109 8.25 7.5V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM6 12.75C6.19891 12.75 6.38968 12.671 6.53033 12.5303C6.67098 12.3897 6.75 12.1989 6.75 12V9C6.75 8.80109 6.67098 8.61032 6.53033 8.46967C6.38968 8.32902 6.19891 8.25 6 8.25C5.80109 8.25 5.61032 8.32902 5.46967 8.46967C5.32902 8.61032 5.25 8.80109 5.25 9V12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303C5.61032 12.671 5.80109 12.75 6 12.75ZM15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V12C14.25 12.1989 14.329 12.3897 14.4697 12.5303C14.6103 12.671 14.8011 12.75 15 12.75C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM15 14.25H3.75V3C3.75 2.80109 3.67098 2.61032 3.53033 2.46967C3.38968 2.32902 3.19891 2.25 3 2.25C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25Z"
                            fill="black"
                          />
                        </svg>
                        Active
                      </label>
                      {/* Doubt */}
                      <h1>
                        {" "}
                        {clientId === clientIdForDashboard &&
                        dashboarddata.meta.totalTemplate !== undefined
                          ? dashboarddata.meta.totalTemplate
                          : 0}
                        <span>Templates</span>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* {dashboarddata && dashboarddata.meta &&  */}
            <div className="col-md-8">
              <div className="consent-status">
                <h4>Consents</h4>
                <div className="status-scroll">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex">
                        <div className="status-box c1 me-3">
                          <label>
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 12.75C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75C11.8011 3.75 11.6103 3.82902 11.4697 3.96967C11.329 4.11032 11.25 4.30109 11.25 4.5V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303C11.6103 12.671 11.8011 12.75 12 12.75ZM9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V7.5C9.75 7.30109 9.67098 7.11032 9.53033 6.96967C9.38968 6.82902 9.19891 6.75 9 6.75C8.80109 6.75 8.61032 6.82902 8.46967 6.96967C8.32902 7.11032 8.25 7.30109 8.25 7.5V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM6 12.75C6.19891 12.75 6.38968 12.671 6.53033 12.5303C6.67098 12.3897 6.75 12.1989 6.75 12V9C6.75 8.80109 6.67098 8.61032 6.53033 8.46967C6.38968 8.32902 6.19891 8.25 6 8.25C5.80109 8.25 5.61032 8.32902 5.46967 8.46967C5.32902 8.61032 5.25 8.80109 5.25 9V12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303C5.61032 12.671 5.80109 12.75 6 12.75ZM15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V12C14.25 12.1989 14.329 12.3897 14.4697 12.5303C14.6103 12.671 14.8011 12.75 15 12.75C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM15 14.25H3.75V3C3.75 2.80109 3.67098 2.61032 3.53033 2.46967C3.38968 2.32902 3.19891 2.25 3 2.25C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25Z"
                                fill="black"
                              />
                            </svg>
                            Total
                          </label>
                          <h1>
                            {clientId === clientIdForDashboard &&
                            dashboarddata.meta.totalConsent !== undefined
                              ? dashboarddata.meta.totalConsent
                              : 0}{" "}
                            <span>Consents</span>
                          </h1>
                        </div>
                        <div className="status-box c2 me-3">
                          <label>
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 12.75C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75C11.8011 3.75 11.6103 3.82902 11.4697 3.96967C11.329 4.11032 11.25 4.30109 11.25 4.5V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303C11.6103 12.671 11.8011 12.75 12 12.75ZM9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V7.5C9.75 7.30109 9.67098 7.11032 9.53033 6.96967C9.38968 6.82902 9.19891 6.75 9 6.75C8.80109 6.75 8.61032 6.82902 8.46967 6.96967C8.32902 7.11032 8.25 7.30109 8.25 7.5V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM6 12.75C6.19891 12.75 6.38968 12.671 6.53033 12.5303C6.67098 12.3897 6.75 12.1989 6.75 12V9C6.75 8.80109 6.67098 8.61032 6.53033 8.46967C6.38968 8.32902 6.19891 8.25 6 8.25C5.80109 8.25 5.61032 8.32902 5.46967 8.46967C5.32902 8.61032 5.25 8.80109 5.25 9V12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303C5.61032 12.671 5.80109 12.75 6 12.75ZM15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V12C14.25 12.1989 14.329 12.3897 14.4697 12.5303C14.6103 12.671 14.8011 12.75 15 12.75C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM15 14.25H3.75V3C3.75 2.80109 3.67098 2.61032 3.53033 2.46967C3.38968 2.32902 3.19891 2.25 3 2.25C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25Z"
                                fill="black"
                              />
                            </svg>
                            Active
                          </label>
                          <h1>
                            {" "}
                            {clientId === clientIdForDashboard &&
                            dashboarddata.meta.totalActiveConsent !== undefined
                              ? dashboarddata.meta.totalActiveConsent
                              : 0}
                            <span>Consents</span>
                          </h1>
                        </div>
                        <div className="status-box c3 me-3">
                          <label>
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 12.75C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75C11.8011 3.75 11.6103 3.82902 11.4697 3.96967C11.329 4.11032 11.25 4.30109 11.25 4.5V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303C11.6103 12.671 11.8011 12.75 12 12.75ZM9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V7.5C9.75 7.30109 9.67098 7.11032 9.53033 6.96967C9.38968 6.82902 9.19891 6.75 9 6.75C8.80109 6.75 8.61032 6.82902 8.46967 6.96967C8.32902 7.11032 8.25 7.30109 8.25 7.5V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM6 12.75C6.19891 12.75 6.38968 12.671 6.53033 12.5303C6.67098 12.3897 6.75 12.1989 6.75 12V9C6.75 8.80109 6.67098 8.61032 6.53033 8.46967C6.38968 8.32902 6.19891 8.25 6 8.25C5.80109 8.25 5.61032 8.32902 5.46967 8.46967C5.32902 8.61032 5.25 8.80109 5.25 9V12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303C5.61032 12.671 5.80109 12.75 6 12.75ZM15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V12C14.25 12.1989 14.329 12.3897 14.4697 12.5303C14.6103 12.671 14.8011 12.75 15 12.75C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM15 14.25H3.75V3C3.75 2.80109 3.67098 2.61032 3.53033 2.46967C3.38968 2.32902 3.19891 2.25 3 2.25C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25Z"
                                fill="black"
                              />
                            </svg>
                            Revoked
                          </label>
                          <h1>
                            {clientId === clientIdForDashboard &&
                            dashboarddata.meta.totalRevokedConsent !== undefined
                              ? dashboarddata.meta.totalRevokedConsent
                              : 0}
                            <span>Consents</span>
                          </h1>
                        </div>
                        <div className="status-box c4 me-3">
                          <label>
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 12.75C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75C11.8011 3.75 11.6103 3.82902 11.4697 3.96967C11.329 4.11032 11.25 4.30109 11.25 4.5V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303C11.6103 12.671 11.8011 12.75 12 12.75ZM9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V7.5C9.75 7.30109 9.67098 7.11032 9.53033 6.96967C9.38968 6.82902 9.19891 6.75 9 6.75C8.80109 6.75 8.61032 6.82902 8.46967 6.96967C8.32902 7.11032 8.25 7.30109 8.25 7.5V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM6 12.75C6.19891 12.75 6.38968 12.671 6.53033 12.5303C6.67098 12.3897 6.75 12.1989 6.75 12V9C6.75 8.80109 6.67098 8.61032 6.53033 8.46967C6.38968 8.32902 6.19891 8.25 6 8.25C5.80109 8.25 5.61032 8.32902 5.46967 8.46967C5.32902 8.61032 5.25 8.80109 5.25 9V12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303C5.61032 12.671 5.80109 12.75 6 12.75ZM15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V12C14.25 12.1989 14.329 12.3897 14.4697 12.5303C14.6103 12.671 14.8011 12.75 15 12.75C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM15 14.25H3.75V3C3.75 2.80109 3.67098 2.61032 3.53033 2.46967C3.38968 2.32902 3.19891 2.25 3 2.25C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25Z"
                                fill="black"
                              />
                            </svg>
                            Expired
                          </label>
                          <h1>
                            {clientId === clientIdForDashboard &&
                            dashboarddata.meta.totalExpiredConsent !== undefined
                              ? dashboarddata.meta.totalExpiredConsent
                              : 0}
                            <span>Consents</span>
                          </h1>
                        </div>

                        <div className='status-box c1 me-3'>
                                                    <label>
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12 12.75C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75C11.8011 3.75 11.6103 3.82902 11.4697 3.96967C11.329 4.11032 11.25 4.30109 11.25 4.5V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303C11.6103 12.671 11.8011 12.75 12 12.75ZM9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V7.5C9.75 7.30109 9.67098 7.11032 9.53033 6.96967C9.38968 6.82902 9.19891 6.75 9 6.75C8.80109 6.75 8.61032 6.82902 8.46967 6.96967C8.32902 7.11032 8.25 7.30109 8.25 7.5V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM6 12.75C6.19891 12.75 6.38968 12.671 6.53033 12.5303C6.67098 12.3897 6.75 12.1989 6.75 12V9C6.75 8.80109 6.67098 8.61032 6.53033 8.46967C6.38968 8.32902 6.19891 8.25 6 8.25C5.80109 8.25 5.61032 8.32902 5.46967 8.46967C5.32902 8.61032 5.25 8.80109 5.25 9V12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303C5.61032 12.671 5.80109 12.75 6 12.75ZM15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V12C14.25 12.1989 14.329 12.3897 14.4697 12.5303C14.6103 12.671 14.8011 12.75 15 12.75C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM15 14.25H3.75V3C3.75 2.80109 3.67098 2.61032 3.53033 2.46967C3.38968 2.32902 3.19891 2.25 3 2.25C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25Z" fill="black"/>
                                                        </svg>
                                                        Rejected
                                                        
                                                    </label>
                                                    <h1>{clientId === clientIdForDashboard && dashboarddata.meta.totalRejectedConsent !== undefined ? dashboarddata.meta.totalRejectedConsent: 0}<span>Consents</span></h1>
                                                </div>
                        {/* <div className='status-box c2'>
                                                    <label>
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12 12.75C12.1989 12.75 12.3897 12.671 12.5303 12.5303C12.671 12.3897 12.75 12.1989 12.75 12V4.5C12.75 4.30109 12.671 4.11032 12.5303 3.96967C12.3897 3.82902 12.1989 3.75 12 3.75C11.8011 3.75 11.6103 3.82902 11.4697 3.96967C11.329 4.11032 11.25 4.30109 11.25 4.5V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303C11.6103 12.671 11.8011 12.75 12 12.75ZM9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12V7.5C9.75 7.30109 9.67098 7.11032 9.53033 6.96967C9.38968 6.82902 9.19891 6.75 9 6.75C8.80109 6.75 8.61032 6.82902 8.46967 6.96967C8.32902 7.11032 8.25 7.30109 8.25 7.5V12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75ZM6 12.75C6.19891 12.75 6.38968 12.671 6.53033 12.5303C6.67098 12.3897 6.75 12.1989 6.75 12V9C6.75 8.80109 6.67098 8.61032 6.53033 8.46967C6.38968 8.32902 6.19891 8.25 6 8.25C5.80109 8.25 5.61032 8.32902 5.46967 8.46967C5.32902 8.61032 5.25 8.80109 5.25 9V12C5.25 12.1989 5.32902 12.3897 5.46967 12.5303C5.61032 12.671 5.80109 12.75 6 12.75ZM15 8.25C14.8011 8.25 14.6103 8.32902 14.4697 8.46967C14.329 8.61032 14.25 8.80109 14.25 9V12C14.25 12.1989 14.329 12.3897 14.4697 12.5303C14.6103 12.671 14.8011 12.75 15 12.75C15.1989 12.75 15.3897 12.671 15.5303 12.5303C15.671 12.3897 15.75 12.1989 15.75 12V9C15.75 8.80109 15.671 8.61032 15.5303 8.46967C15.3897 8.32902 15.1989 8.25 15 8.25ZM15 14.25H3.75V3C3.75 2.80109 3.67098 2.61032 3.53033 2.46967C3.38968 2.32902 3.19891 2.25 3 2.25C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V15C2.25 15.1989 2.32902 15.3897 2.46967 15.5303C2.61032 15.671 2.80109 15.75 3 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25Z" fill="black"/>
                                                        </svg>
                                                        Total
                                                        
                                                    </label>
                                                    <h1>{clientId === clientIdForDashboard && dashboarddata.meta.totalTemplate}<span>Consent Groups</span></h1>
                                                </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* } */}
          </div>
          <div className="row mt-4">
            <div className="col-md-12">
              <div class="card custom-cards">
                <div class="card-body">
                  <div className="row">
                    {/* <div className="col-md-4">
                      <h4>Consents</h4>
                      <div className="text-center my-4">

      


                      </div>
                      <div className="chat-legend">
                        <ul>
                          <li className="active">
                            {clientId === clientIdForDashboard &&
                            dashboarddata.meta.totalActiveConsent !== undefined
                              ? dashboarddata.meta.totalActiveConsent
                              : 0}
                            <span>Active</span>
                          </li>
                       
                          <li className="revoked">
                            {" "}
                            {clientId === clientIdForDashboard &&
                            dashboarddata.meta.totalRevokedConsent !== undefined
                              ? dashboarddata.meta.totalRevokedConsent
                              : 0}
                            <span>Revoked</span>
                          </li>
                          <li>
                            {clientId === clientIdForDashboard &&
                            dashboarddata.meta.totalExpiredConsent !== undefined
                              ? dashboarddata.meta.totalExpiredConsent
                              : 0}
                            <span>Expired</span>
                          </li>
                          <li>{clientId === clientIdForDashboard && dashboarddata.meta.totalRejectedConsent !== undefined
                              ? dashboarddata.meta.totalRejectedConsent
                            : 0}<span>Rejected</span></li>
                        </ul>
                      </div>
                    </div> */}
                    <div className="col-md-12">
                      <div class="card custom-cards dark no-shadow" style={{height:'fit-content'}}>
                        <div class="card-body">
                          <div className="row align-items-center">
                            <div className="col-8">
                              <h4 className="m-0">Monthwise Consents</h4>
                            </div>
                            <div className="col-4">
                              {/* <TextField
                                fullWidth
                                size="small"
                                select
                                label="Monthly"
                                variant="standard"
                                name="select1"
                                value={values.select1}
                                onChange={handleChange}
                              >
                                <MenuItem value="USD">Company 1</MenuItem>
                                <MenuItem value="EUR">Company 2</MenuItem>
                                <MenuItem value="BTC">Company 3</MenuItem>
                              </TextField> */}
                            </div>
                          </div>
                          
                          {dataPoints && dataPoints.length ? (
                              <div className="text-center my-4">
                                <CanvasJSChart options={optionsGraph} />
                              </div>
                            ) : (
                              <div className="text-center">No data available</div>
                            )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-12">
              <div class="card custom-cards">
                <div class="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <h4 className="m-0">Published Consent Groups</h4>
                    </div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col-md-4">
                          {/* <TextField
                            fullWidth
                            size="small"
                            select
                            label="Search Table"
                            variant="standard"
                            name="select2"
                            value={values.select2}
                            onChange={handleChange}
                          >
                            <MenuItem value="USD">Company 1</MenuItem>
                            <MenuItem value="EUR">Company 2</MenuItem>
                            <MenuItem value="BTC">Company 3</MenuItem>
                          </TextField> */}
                        </div>
                        <div className="col-md-4">
                          {/* <TextField
                            fullWidth
                            size="small"
                            select
                            label="Select Date"
                            variant="standard"
                            name="select3"
                            value={values.select3}
                            onChange={handleChange}
                          >
                            <MenuItem value="USD">Company 1</MenuItem>
                            <MenuItem value="EUR">Company 2</MenuItem>
                            <MenuItem value="BTC">Company 3</MenuItem>
                          </TextField> */}
                        </div>
                        <div className="col-md-4">
                          {/* <TextField
                            fullWidth
                            size="small"
                            select
                            label="Status"
                            variant="standard"
                            name="select4"
                            value={values.select4}
                            onChange={handleChange}
                          >
                            <MenuItem value="USD">Company 1</MenuItem>
                            <MenuItem value="EUR">Company 2</MenuItem>
                            <MenuItem value="BTC">Company 3</MenuItem>
                          </TextField> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive mt-4">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">S. No.</th>
                              <th scope="col">Consent Group Name</th>
                              <th scope="col">Template Count</th>
                              <th scope="col">Date</th>
                              <th scope="col">Total Consents</th>
                              <th scope="col">Active</th>
                              <th scope="col">Revoked</th>

                              <th scope="col">Expired</th>
                              <th scope="col">Rejected</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dashboarddata &&
                              dashboarddata.templateDetails &&
                              dashboarddata.templateDetails.length > 0 &&
                              dashboarddata.templateDetails.map(
                                (element, key) => (
                                  <React.Fragment key={key}>
                                   
                                      <tr key={element.consentGroupId}>
                                        <td>{key + 1}</td>
                                        <td><Link onClick={()=>handleObjectTransfer(element)} style={{textDecoration:'none'}}>{element.consentGroupName}</Link></td>
                                        <td>{element.meta.totalTemplate}</td>
                                        <td>{formatDate(element.createdTimestamp)}</td>
                                        <td>{element.meta.totalConsent}</td>
                                        <td>
                                          {element.meta.totalActiveConsent}
                                        </td>
                                        <td>
                                          {element.meta.totalRevokedConsent}
                                        </td>
                                        <td>
                                        {element.meta.totalExpiredConsent} 
                                        </td>
                                        <td>

                                        {element.meta.totalRejectedConsent}
                                        </td>
                                      </tr>
                                    
                                  </React.Fragment>
                                )
                              )}
                          </tbody>

                          {/* <tbody className="text-left">
                { dashboarddata &&  dashboarddata.templateDetails && dashboarddata.templateDetails.length > 0 &&
                dashboarddata.templateDetails.map((element,key)=>(
                  <React.Fragment key={key}>
                  { 
                  element.status === 'ACTIVE' &&
                  <tr key={key} >
                    <td onClick={()=>{ viewDetail(element)}} className="link-primary"> {element.nickName}</td>
                    <td style={{color:'#17a2b8', fontWeight:'bold'}}>{element.consentCount}</td>
                    <td style={{color:'green', fontWeight:'bold'}}>{element.consentDetails.active}</td>
                    <td style={{color:'red', fontWeight:'bold'}}>{element.consentDetails.revoked}</td>
                    <td style={{color:'#ffc107', fontWeight:'bold'}}>{element.consentDetails.expired}</td>
                    {/* <td className="text-success">{element.status}</td> */}
                          {/* </tr> */}

                          {/* } */}
                          {/* </React.Fragment> */}
                          {/* ))   */}
                          {/* } */}

                          {/* </tbody>   */}
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center">
                    <div className="col-md-auto me-auto ">

                    {dashboarddata &&
                        dashboarddata.templateDetails &&
                        dashboarddata.templateDetails.length > 0 ? (
                          <div className="dt-info">
                            Showing 1 to {dashboarddata.templateDetails.length} entries of {dashboarddata.templateDetails.length} entries
                          </div>
                        ) : (
                          <div>
                            {dashboarddata && dashboarddata.templateDetails 
                              ? `${dashboarddata.templateDetails.length} entries present`
                              : "No entries present"}
                          </div>
                        )}

                    </div>



                    {/* <div className="col-md-auto ms-auto ">
                      <div className="dt-paging paging_full_numbers">
                        <ul className="pagination">
                          <li className="dt-paging-button page-item disabled">
                            <a href="#!" className="page-link first">
                              <svg
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.05192 2.66667C4.68525 2.66667 4.38525 2.96667 4.38525 3.33333V12.6667C4.38525 13.0333 4.68525 13.3333 5.05192 13.3333C5.41859 13.3333 5.71859 13.0333 5.71859 12.6667V3.33333C5.71859 2.96667 5.41859 2.66667 5.05192 2.66667ZM8.65859 8L12.8519 3.80667C13.1119 3.54667 13.1119 3.12667 12.8519 2.86667C12.5919 2.60667 12.1719 2.60667 11.9119 2.86667L7.24525 7.53333C6.98525 7.79333 6.98525 8.21333 7.24525 8.47333L11.9119 13.14C12.0453 13.2733 12.2119 13.3333 12.3853 13.3333C12.5586 13.3333 12.7253 13.2667 12.8586 13.14C13.1186 12.88 13.1186 12.46 12.8586 12.2L8.66525 8.00667L8.65859 8Z"
                                  fill="#000093"
                                />
                              </svg>
                            </a>
                          </li>
                          <li className="dt-paging-button page-item disabled">
                            <a href="#!" className="page-link previous">
                              <svg
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.3851 13.3335C10.2973 13.334 10.2103 13.3171 10.1291 13.284C10.0479 13.2508 9.97401 13.2019 9.91172 13.1401L5.24505 8.47346C5.18256 8.41148 5.13297 8.33775 5.09912 8.25651C5.06528 8.17527 5.04785 8.08813 5.04785 8.00012C5.04785 7.91212 5.06528 7.82498 5.09912 7.74374C5.13297 7.6625 5.18256 7.58877 5.24505 7.52679L9.91172 2.86012C9.97388 2.79796 10.0477 2.74866 10.1289 2.71502C10.2101 2.68138 10.2971 2.66406 10.3851 2.66406C10.473 2.66406 10.56 2.68138 10.6412 2.71502C10.7224 2.74866 10.7962 2.79796 10.8584 2.86012C10.9205 2.92228 10.9699 2.99608 11.0035 3.07729C11.0371 3.15851 11.0544 3.24555 11.0544 3.33346C11.0544 3.42136 11.0371 3.50841 11.0035 3.58962C10.9699 3.67084 10.9205 3.74463 10.8584 3.80679L6.65838 8.00012L10.8584 12.1935C10.9209 12.2554 10.9705 12.3292 11.0043 12.4104C11.0382 12.4916 11.0556 12.5788 11.0556 12.6668C11.0556 12.7548 11.0382 12.8419 11.0043 12.9232C10.9705 13.0044 10.9209 13.0781 10.8584 13.1401C10.7961 13.2019 10.7222 13.2508 10.641 13.284C10.5598 13.3171 10.4728 13.334 10.3851 13.3335Z"
                                  fill="#000093"
                                />
                              </svg>
                            </a>
                          </li>
                          <li className="dt-paging-button page-item active">
                            <a href="#" className="page-link">
                              1
                            </a>
                          </li>
                          <li className="dt-paging-button page-item">
                            <a href="#" className="page-link">
                              2
                            </a>
                          </li>
                          <li className="dt-paging-button page-item">
                            <a href="#" className="page-link">
                              3
                            </a>
                          </li>
                          <li className="dt-paging-button page-item">
                            <a href="#" className="page-link next">
                              <svg
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.38538 13.3335C6.29764 13.334 6.21066 13.3171 6.12944 13.284C6.04821 13.2508 5.97434 13.2019 5.91204 13.1401C5.84956 13.0781 5.79996 13.0044 5.76612 12.9232C5.73227 12.8419 5.71484 12.7548 5.71484 12.6668C5.71484 12.5788 5.73227 12.4916 5.76612 12.4104C5.79996 12.3292 5.84956 12.2554 5.91204 12.1935L10.112 8.00012L5.91204 3.80679C5.78651 3.68125 5.71598 3.51099 5.71598 3.33346C5.71598 3.15592 5.78651 2.98566 5.91204 2.86012C6.03758 2.73459 6.20784 2.66406 6.38538 2.66406C6.56291 2.66406 6.73317 2.73459 6.85871 2.86012L11.5254 7.52679C11.5879 7.58877 11.6375 7.6625 11.6713 7.74374C11.7051 7.82498 11.7226 7.91212 11.7226 8.00012C11.7226 8.08813 11.7051 8.17527 11.6713 8.25651C11.6375 8.33775 11.5879 8.41148 11.5254 8.47346L6.85871 13.1401C6.79642 13.2019 6.72254 13.2508 6.64131 13.284C6.56009 13.3171 6.47311 13.334 6.38538 13.3335Z"
                                  fill="#000093"
                                />
                              </svg>
                            </a>
                          </li>
                          <li className="dt-paging-button page-item">
                            <a href="#!" className="page-link last">
                              <svg
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4.85863 2.86C4.59863 2.6 4.17863 2.6 3.91863 2.86C3.65863 3.12 3.65863 3.54 3.91863 3.8L8.11197 7.99333L3.91863 12.1867C3.65863 12.4467 3.65863 12.8667 3.91863 13.1267C4.05197 13.26 4.21863 13.32 4.39197 13.32C4.5653 13.32 4.73197 13.2533 4.8653 13.1267L9.53197 8.46C9.79197 8.2 9.79197 7.78 9.53197 7.52L4.85863 2.86ZM11.7186 2.66667C11.352 2.66667 11.052 2.96667 11.052 3.33333V12.6667C11.052 13.0333 11.352 13.3333 11.7186 13.3333C12.0853 13.3333 12.3853 13.0333 12.3853 12.6667V3.33333C12.3853 2.96667 12.0853 2.66667 11.7186 2.66667Z"
                                  fill="#000093"
                                />
                              </svg>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div> */}





                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer></ToastContainer>
    </>
  );
};

export default Dashboard;
